import { Principal } from 'pages/contentprincipal/Principal'
import { RouteObject } from 'react-router-dom'
//import { OrdenCompras2 } from "pages/contentcompras/OrdenCompras2"
import GenerarOrden from 'components/compras/GenerarOrden'
import VisorMartillo from "pages/productos/VisorMartillo";

export const rutasCompras: RouteObject[] = [
    {
      path: "/compras",
      element: <Principal />,
    },
/*     {
      path: "/compras/orden-compras",
      element: <OrdenCompras/>,
    }, */
    {
      path: "/compras/orden-compras",
      element: <VisorMartillo />,
    },
]
